// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__AvNGd","modalBody":"styles_modalBody__7Nrbn","close":"styles_close__KqzcL","btnConfirm":"styles_btnConfirm__q9Ul3"};